module.exports = __webpack_public_path__ + "img/research-img-tab.93de9f70.jpg";